module.exports = __webpack_public_path__ + "media/images/club-811bedc73eade148b737b97c5a36cb9c.jpeg";